var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.25 3c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v11a.75.75 0 0 1-1.28.53L8 11.06l-3.47 3.47A.75.75 0 0 1 3.25 14V3zM5 2.75a.25.25 0 0 0-.25.25v9.19l2.72-2.72a.75.75 0 0 1 1.06 0l2.72 2.72V3a.25.25 0 0 0-.25-.25H5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export default ForwardRef;